import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (data: any) => {
  return {
    mid: data?.mid,
    packageName: data?.packageName,
    fileType: data?.fileType,
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addPackageToMId = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingMid2PackCreate),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addPackageToMId }
